import { SmokingOffIcon } from './SmokingOffIcon';

/**
 * author: Google
 * id 5F974B83-AEEC-4C52-B281-1A8663B70027
 * name smoking-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/smoking-off.svg
 * tags
 */
export const CigaretteOffIcon = SmokingOffIcon;
export default CigaretteOffIcon